import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Dimmer, Loader, Icon } from 'semantic-ui-react';
import ModalHeader from '../drive/ModalHeader';
import logo from "../../images/logo/logo-white.png";

class VerifyComponent extends React.Component {
    componentDidMount() {
        const storedUserId = sessionStorage.getItem('pendingVerificationUserId');
        if (storedUserId && !this.props.pendingVerificationUserId) {
            dispatch.login.setPendingVerificationUserId(storedUserId);
        }
        const storedEmail = sessionStorage.getItem('pendingVerificationEmail');
        if (storedEmail && !this.props.pendingVerificationEmail) {
            dispatch.login.setPendingVerificationEmail(storedEmail);
        }
    }
    
    render() {
        const { version, autoLoggingIn, pendingVerificationEmail, history } = this.props;
        const date = new Date();

        return (
            <div className="login-main" style={{ height: '100%' }}>
                {autoLoggingIn && (
                    <Dimmer inverted active page>
                        <Loader size="massive">
                            Your email has been verified. Logging you in now — please wait.
                        </Loader>
                    </Dimmer>
                )}
                <div className="left-section">
                    <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                        <h2 className="f_24 ff_b float-left" style={{ color:"#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px" }}>
                            <a href="#" onClick={() => history.push("/newaccount")} id="backLink" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "28px", height: "28px",
                                border: "1px solid #d4d4d4", borderRadius: "6px",
                                color: "#707070", textDecoration: "none"
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </a>
                            Sign Up
                        </h2>

                        <div
                            style={{
                                backgroundColor: "#f2f2f2",
                                width: "370px",
                                marginTop: "20px",
                                padding: "10px 20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "8px",
                                border: "1px solid #228B22",
                                color: "#228B22",
                                fontWeight: "bold",
                                fontSize: "16px"
                            }}
                        >
                            <Icon
                                name="envelope"
                                style={{
                                    marginRight: "10px",
                                    color: "#228B22",
                                    fontSize: "16px"
                                }}
                            />
                            <p style={{ fontSize: "13px" }}>
                                Check your email{pendingVerificationEmail ? <> at <strong>{pendingVerificationEmail}</strong></> : ''} to verify your account.
                            </p>
                        </div>
                    </div>
                    <div className="f_10 mar_0 bottom" style={{ height: "46px", padding: "5px 10px", width: "100%" }}>
                        <div className="float-left">
                            Copyright &#169; {date.getFullYear()} Aspenify <br />Version {version ? version : ""}
                        </div>
                        <div className="float-right text-right">
                            Visit us at <br />
                            <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank"> www.aspenify.com </a>
                        </div>
                    </div>
                </div>
                <div className="right-section display-flex" style={{ flexDirection: 'column' }}>
                    <div className='login-right-div'>
                        <div>
                            <ModalHeader
                                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor: 'pointer' }} /></a>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        version: state.login.version,
        pendingVerificationUserId: state.login.pendingVerificationUserId,
        pendingVerificationEmail: state.login.pendingVerificationEmail,
        autoLoggingIn: state.loading.effects.login.autoLoginWithToken,
    };
}

export default withRouter(connect(mapStateToProps)(VerifyComponent));
